//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generateComputed } from '../../common/functions/roles-computed-generator';
import TipoInvestimentoForm from './TipoInvestimentoForm';
import TipoInvestimentoTabela from './TipoInvestimentoTabela';

export default {
  name: 'TipoInvestimento',
  data() {
    return {
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
    };
  },
  components: {
    TipoInvestimentoForm,
    TipoInvestimentoTabela,
  },
  computed: {
    ...generateComputed('tipo linha', [
      'canAccessCRUD',
      'canAccessPage',
    ]),
    somenteLeitura() {
      return !this.canAccessCRUD;
    },
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
      }
    },
    onCancelar() {
      this.$refs.tipoInvestimentoTabela.filtrar();
    },
    onEditar(item) {
      this.$refs.tipoInvestimentoForm.editar(item);
    },
    onNovo() {
      this.$refs.tipoInvestimentoTabela.filtrar();
    },
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/spa/tipo-investimento/TipoInvestimento.vue?vue&type=script&lang=js&